import type { OfficeRoom } from "./types";

export const OFFICE_ROOMS: OfficeRoom[] = [
  {
    id: "brilliant",
    name: "Brilliant",
    info: {
      capacity: { friendlyName: "Kapasitet", value: 20 },
      functionality: {
        friendlyName: "Funksjonalitet",
        value: 'Teamsrom 2 x 65" skjermer, whiteboard, whiteboardkamera',
      },
      oldName: { friendlyName: "Gammelt navn", value: "Konferanse" },
    },
  },
  {
    id: "gaming-room",
    name: "Gaming-rommet",
    info: {
      capacity: { friendlyName: "Kapasitet", value: 6 },
      functionality: {
        friendlyName: "Funksjonalitet",
        value: '2 x 65" skjermer, kamera, 5 x gaming-PC med fullt oppsett',
      },
    },
  },
  {
    id: "lagspill",
    name: "Lagspill",
    info: {
      capacity: { friendlyName: "Kapasitet", value: 8 },
      functionality: {
        friendlyName: "Funksjonalitet",
        value: 'Teamsrom 2 x 65" skjermer, whiteboard, whiteboardkamera',
      },
      oldName: { friendlyName: "Gammelt navn", value: "Grønt" },
    },
  },
  {
    id: "aapenhet",
    name: "Åpenhet",
    info: {
      capacity: { friendlyName: "Kapasitet", value: 8 },
      functionality: {
        friendlyName: "Funksjonalitet",
        value: 'Teamsrom 2 x 65" skjermer',
      },
      oldName: { friendlyName: "Gammelt navn", value: "Rødt" },
    },
  },
  {
    id: "work-hub-1",
    name: "Work Hub 1",
    info: {
      capacity: { friendlyName: "Kapasitet", value: 1 },
      functionality: {
        friendlyName: "Funksjonalitet",
        value: "Arbeidsstasjon med skjerm og tastatur",
      },
      oldName: { friendlyName: "Gammelt navn", value: "Telefonrom 1" },
    },
  },
  {
    id: "work-hub-2",
    name: "Work Hub 2",
    info: {
      capacity: { friendlyName: "Kapasitet", value: 1 },
      functionality: {
        friendlyName: "Funksjonalitet",
        value: "Arbeidsstasjon med skjerm og tastatur",
      },
      oldName: { friendlyName: "Gammelt navn", value: "Telefonrom 2" },
    },
  },
  {
    id: "integritet",
    name: "Integritet",
    info: {
      capacity: { friendlyName: "Kapasitet", value: 4 },
      functionality: {
        friendlyName: "Funksjonalitet",
        value: '55" skjerm, kamera',
      },
      oldName: { friendlyName: "Gammelt navn", value: "Videorom" },
    },
  },
  {
    id: "entusiasme",
    name: "Entusiasme",
    info: {
      capacity: { friendlyName: "Kapasitet", value: 4 },
      functionality: {
        friendlyName: "Funksjonalitet",
        value: '55" skjerm, kamera',
      },
      oldName: { friendlyName: "Gammelt navn", value: "Videorom" },
    },
  },
  {
    id: "fremoverlent",
    name: "Fremoverlent",
    info: {
      capacity: { friendlyName: "Kapasitet", value: 2 },
      functionality: {
        friendlyName: "Funksjonalitet",
        value: '55" skjerm, kamera',
      },
      oldName: { friendlyName: "Gammelt navn", value: "Blått" },
    },
  },
];
